module.exports = __webpack_public_path__ + "img/fwhm.17a5ba24.png";